import { useEffect, useState } from "react";
import axios from "./utils/axios";
import Avatar from "./VibhutUI/Avatar";
import EventCard from "./VibhutUI/Card/EventCard";
import HomeIcon from "./VibhutUI/Icons/HomeIcon";
import { useParams } from "react-router";
import { frontEndURL } from "./utils/axios";

const RoomNotFound = () => (
  <div
    className="relative rounded-xl"
    style={{
      height: "250px",
      background: "linear-gradient(180deg, #011AFF 0%, #716DFF 100%)",
    }}
  >
    <div
      style={{ width: "245px", fontSize: "23px" }}
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full"
    >
      <p className="text-white font-medium text-center">
        <div
          style={{ width: "320px", fontSize: "23px" }}
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full"
        >
          <p className="text-white font-medium text-center">
            Start a 1-on-1 video call with another human on Vibehut
          </p>
        </div>
      </p>
    </div>
    <div className={`absolute bottom-4 w-full px-4`}>
      <a
        href={frontEndURL}
        target="_blank"
        className="w-full bg-frescoWhite text-sm py-2 text-navyGray font-ubuntu block text-center"
        style={{ borderRadius: "60px" }}
        rel="noreferrer"
      >
        Explore Vibehut
      </a>
    </div>
    <div className={`absolute top-3 right-3`}>
      <HomeIcon />
    </div>
  </div>
);

const OnlyRoom = ({ roomData, roomId }) => (
  <div className="relative rounded-xl cursor-pointer">
    <img
      src={roomData?.cover?.urls?.regular || "/images/Frame 61.png"}
      alt="banner"
      className="w-full h-48 object-cover rounded-xl"
      style={{ height: "250px" }}
    />
    <div className="absolute bg-gray-700 opacity-50  top-0 bottom-0 left-0 right-0 rounded-xl"></div>
    <div
      style={{ width: "245px", fontSize: "23px" }}
      className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full"
    >
      <p className="text-white font-medium text-center">{roomData?.name}</p>
    </div>
    <div className={`absolute top-3 right-3`}>
      <HomeIcon />
    </div>

    <div className={`absolute bottom-4 w-full px-4`}>
      <a
        href={`${frontEndURL}/rooms/${roomId}`}
        target="_blank"
        className="w-full bg-frescoWhite text-sm py-2 text-navyGray font-ubuntu block text-center"
        style={{ borderRadius: "60px" }}
        rel="noreferrer"
      >
        View Vibehut Room
      </a>
    </div>
  </div>
);

function App() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [avatarSize, setAvatarSize] = useState("54");
  const { roomId } = useParams();
  const [roomData, setRoomData] = useState({});
  const [events, setEvents] = useState([]);
  const [users, setUsers] = useState([]);
  const [liveUsersCount, setLiveUsersCount] = useState(0);
  const [showUserTooltip, setShowUserTooltip] = useState(false);
  const [roomNotFound, setRoomNotFound] = useState(false);
  const [username, setUsername] = useState("");
  useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenWidth(window.innerWidth);
    });

    if (screenWidth < 1380 && screenWidth > 1024) {
      setAvatarSize("sm");
    } else if (screenWidth < 850 && screenWidth > 760) {
      setAvatarSize("sm");
    } else {
      setAvatarSize("54");
    }
  }, [screenWidth]);
  useEffect(() => {
    axios.get(`/rooms/embed/${roomId}`).then((res) => {
      if (res.status === 200) {
        setRoomData(res.data.data.room);
        setEvents(res.data.data.events);
        setUsers(res.data.data.talkingUsers);
        setLiveUsersCount(res.data.data.liveUsersCount);
      } else {
        setRoomNotFound(true);
        console.log(res);
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="bg-white dark:bg-darkNight rounded-2xl">
      {!roomNotFound ? (
        liveUsersCount === 0 && events && events.length === 0 ? (
          <OnlyRoom roomId={roomId} roomData={roomData} />
        ) : (
          <div className="">
            <div className="relative rounded-xl cursor-pointer">
              <img
                src={roomData?.cover?.urls?.regular || "/images/Frame 61.png"}
                alt="banner"
                className="w-full h-48 object-cover rounded-t-xl"
                style={{ height: "225px" }}
              />
              <div className="absolute bg-gray-700 opacity-50  top-0 bottom-0 left-0 right-0 rounded-t-xl"></div>
              <div
                style={{ width: "245px", fontSize: "23px" }}
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full"
              >
                <p className="text-white font-medium text-center">
                  <a
                    href={`${frontEndURL}/rooms/${roomId}`}
                    target="_blank"
                    className=""
                    rel="noreferrer"
                  >
                    {roomData?.name}
                  </a>
                </p>
              </div>
              <div className={`absolute top-3 right-3`}>
                <HomeIcon />
              </div>
            </div>
            <div className="w-full p-4 rounded-b-xl border border-lightGray border-t-0 ">
              {liveUsersCount > 0 && (
                <div>
                  <p className="uppercase text-sm font-medium text-darkGray font-ubuntu">
                    {liveUsersCount} TALKING
                  </p>
                  <div className="flex pt-2 space-x-3.5">
                    {users &&
                      users.length > 0 &&
                      users.slice(0, 6).map((user, index) => (
                        <div
                          key={index}
                          className="relative"
                          onMouseEnter={() => {
                            setShowUserTooltip(true);
                            setUsername(user.username);
                          }}
                          onMouseLeave={() => {
                            setShowUserTooltip(false);
                            setUsername("");
                          }}
                        >
                          <Avatar
                            size={avatarSize}
                            src={user.profile_picture}
                            username={user.username}
                          />
                          {showUserTooltip && username === user.username && (
                            <UsernameTooltip text={user.username} />
                          )}
                        </div>
                      ))}
                    {liveUsersCount > 6 && (
                      <div
                        className={`avatar-${avatarSize} bg-lightGray flex justify-center items-center text-sm font-bold font-ubuntu text-darkGray`}
                      >
                        {liveUsersCount - 6}+
                      </div>
                    )}
                  </div>
                </div>
              )}
              {events && events.length > 0 && (
                <div className={`${liveUsersCount > 0 ? "pt-6" : ""}`}>
                  <p className="uppercase text-sm font-medium text-darkGray font-ubuntu">
                    Events
                  </p>
                  <div className="pt-2">
                    {events.slice(0, 2).map((event) => (
                      <div className="pt-1">
                        <EventCard event={event} roomId={roomId} />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {(liveUsersCount > 0 || (events && events.length > 0)) && (
                <div className="pt-4">
                  <a
                    href={`${frontEndURL}/rooms/${roomId}`}
                    target="_blank"
                    className="w-full border border-primary text-sm py-2 text-primary font-ubuntu block text-center"
                    style={{ borderRadius: "60px" }}
                    rel="noreferrer"
                  >
                    View Vibehut Room
                  </a>
                </div>
              )}
            </div>
          </div>
        )
      ) : (
        <RoomNotFound />
      )}
    </div>
  );
}

export default App;

function UsernameTooltip({ text }) {
  return (
    <div className={`absolute -top-11 -left-7`}>
      <div className="relative">
        <div
          className={`font-medium  py-1.5 text-sm bottom-full bg-darkNight dark:bg-frescoWhite rounded-lg  text-white dark:text-darkNight w-28`}
        >
          <div>
            <p className="font-medium text-md text-center">{text}</p>
          </div>
        </div>

        <svg
          className="absolute text-darkNight dark:text-frescoWhite h-5 w-full left-0 top-full"
          x="0px"
          y="0px"
          viewBox="0 0 255 255"
        >
          <polygon className="fill-current" points="0,0 127.5,127.5 255,0" />
        </svg>
      </div>
    </div>
  );
}
